import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './PickupButtons.css';
import Button from '../../components/UI/Button/Button';


class PickupButtons extends Component {
    render () {        
        return (
            <div className={classes.OrderButtons}>
                
                <Button 
                    btnType="Success"
                    clicked={this.props.onLoad}>LOAD PICKUP</Button>

                <Button 
                    btnType="Danger"
                    clicked={this.props.onCancelled}>CANCEL</Button>
            </div>
        );
    }
};


const mapStateToProps = state => {
    return {
        isAuthenticated: state.orders.token !== null
    };
}


export default connect(mapStateToProps)( PickupButtons);


// WEBPACK FOOTER //
// ./src/components/PickupButtons/PickupButtons.js